import React, { FunctionComponent } from 'react';
import {app} from 'b302-frontend-library';

import Bar from '../../../layout/Bar';
import CloseButton from '../../../layout/CloseButton';
import {RESET_UNIVERSITY_FILTER} from '../../../../utils/Events';
import HanText from '../../../utils/HanText';

interface Props {
    children: any;
    toggleMenu: () => void;
    activeFilters?: number;
}

const FilterPageFilter: FunctionComponent<Props> = ({ children, toggleMenu,activeFilters }) => {

    const resetFilter = () => {
        app().emitEvent(RESET_UNIVERSITY_FILTER);
    };

    return (
        <React.Fragment>
            <div className={'filter-page__filter-bar'}>
                <Bar right={<CloseButton onClick={toggleMenu} className={'filter-page__close-button'}/>}>
                    <span className={'filter-page__text filter-page__text--bold filter-page__reset-button filter-page__button'} onClick={resetFilter}>Alles wissen</span>
                    <HanText bold indicatorText={activeFilters?.toString()} className={'filter-page__button'}>Filter options</HanText>
                </Bar>
            </div>

            <div className={'filter-page__filter'}>
                { children }
            </div>
        </React.Fragment>
    );
};

export default FilterPageFilter;
